import React from 'react'
import About from './About'
import Mission from './Mission'
import WhyChooseOurSchool from './WhyChooseOurSchool'

function Allabout() {
  return (
    <div>
        <About/>
        <Mission/>
        <WhyChooseOurSchool/>
    </div>
  )
}

export default Allabout